var _clipPath, _clipPath2, _clipPath3, _clipPath4, _clipPath5, _g, _g2, _g3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgError404(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 500 500",
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeMiterlimit: 10
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.19278,0,0,1.19278,-65.1849,-60.0207)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-35"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M68.67,380.53L59.49,380.53",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(38,50,56)",
      strokeWidth: "1.11px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.51,380.53L83.19,380.53",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(38,50,56)",
      strokeWidth: "1.11px"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 306.07,
    cy: 410.55,
    rx: 30.39,
    ry: 8.36,
    style: {
      fill: "rgb(38,50,56)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149,429.54C117.37,429.54 112.7,424.97 112.24,421.28C112.028,419.723 112.562,418.154 113.68,417.05C122.2,408.11 171.3,411.89 239.24,417.12C248.72,417.85 258.52,418.6 268.57,419.35C337.22,424.45 364.86,423.79 370.57,416.89C371.73,415.48 371.97,413.72 371.33,411.34C368.61,401.39 332.25,401.34 318.48,402.12C317.829,402.154 317.263,401.651 317.22,401C317.219,400.976 317.218,400.952 317.218,400.929C317.218,400.303 317.715,399.781 318.34,399.75C323.61,399.44 369.91,397.11 373.62,410.75C374.47,413.89 374.08,416.4 372.4,418.44C365.99,426.22 339.75,427.05 268.4,421.75C258.34,421 248.54,420.25 239.06,419.52C174.3,414.52 123.14,410.59 115.4,418.72C114.78,419.309 114.481,420.163 114.6,421.01C114.89,423.37 120.6,428.65 166.6,426.81C192.33,425.81 218.18,422.98 218.44,422.95C218.456,422.949 218.472,422.949 218.488,422.949C219.141,422.949 219.678,423.486 219.678,424.139C219.678,424.712 219.264,425.208 218.7,425.31C218.44,425.31 192.51,428.15 166.7,429.18C160.06,429.42 154.18,429.54 149,429.54Z",
    style: {
      fill: "white",
      fillRule: "nonzero",
      stroke: "rgb(38,50,56)",
      strokeWidth: "1.11px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 294.77,
    cy: 382.08,
    r: 35.81,
    style: {
      fill: "white"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M294.77,417.89C294.778,417.89 294.786,417.89 294.793,417.89C314.433,417.89 330.593,401.729 330.593,382.09C330.593,374.883 328.417,367.84 324.35,361.89C323.96,377.49 315.35,400.52 270.57,408.44C277.16,414.518 285.805,417.894 294.77,417.89Z",
    style: {
      fill: "rgb(15,152,247)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.77,417.89C294.778,417.89 294.786,417.89 294.793,417.89C314.433,417.89 330.593,401.729 330.593,382.09C330.593,374.883 328.417,367.84 324.35,361.89C323.96,377.49 315.35,400.52 270.57,408.44C277.16,414.518 285.805,417.894 294.77,417.89Z",
    style: {
      fill: "white",
      fillOpacity: 0.3,
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.39,396.12C306.004,389.908 298.249,385.28 289.75,382.61C298.249,385.28 306.004,389.908 312.39,396.12L314.29,396.12C318.505,391.942 322.134,387.212 325.08,382.06C308.31,364.34 292,366.15 292,366.15C292,366.15 308.36,364.34 325.13,382.08C326.05,380.43 326.82,378.88 327.45,377.45C320.47,367.67 308.45,361 302,360L300.5,359.64C298.188,359.22 295.823,359.186 293.5,359.54C295.823,359.186 298.188,359.22 300.5,359.64L304.77,347.64C302.752,347.063 300.688,346.665 298.6,346.45C295.83,350.92 288.7,365.2 288.7,393.53C288.7,365.2 295.83,350.92 298.6,346.45C297.4,346.34 296.2,346.27 294.97,346.27C293.617,346.274 292.264,346.354 290.92,346.51C286.7,352.89 278.63,367.96 278.09,390.58C286.46,393.63 297.66,395.91 312.39,396.12ZM320.48,388.83C306.22,374.93 290.48,374.2 290.48,374.2C290.48,374.2 306.22,374.93 320.48,388.83Z",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(38,50,56)",
      strokeWidth: "1.11px",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.05,390.64C278.59,368.02 286.66,352.95 290.88,346.57C287.578,346.94 284.344,347.768 281.27,349.03C273.692,360.147 269.41,373.184 268.92,386.63C271.857,388.198 274.909,389.538 278.05,390.64Z",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(38,50,56)",
      strokeWidth: "1.11px",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.27,349C268.675,354.193 260.081,366.129 259.15,379.72C262.094,382.427 265.379,384.74 268.92,386.6C269.41,373.154 273.692,360.117 281.27,349Z",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(38,50,56)",
      strokeWidth: "1.11px",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.4,377.45C328.179,375.728 328.847,373.958 329.4,372.15C327.905,367.05 325.299,362.344 321.77,358.37L319,367.61L321.72,358.37C319.511,355.892 316.971,353.732 314.17,351.95L311.12,363.36L314.19,352C311.262,350.127 308.075,348.695 304.73,347.75L300.46,359.75C307,360.69 317.11,364.54 327.4,377.45Z",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(38,50,56)",
      strokeWidth: "1.11px",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.77,383.77L330.77,382.21C330.77,378.805 330.285,375.418 329.33,372.15C328.777,373.958 328.109,375.728 327.33,377.45C326.901,378.507 326.393,379.53 325.81,380.51C325.87,380.57 324.95,382.02 325.01,382.08C325.07,382.14 324.01,383.88 324.01,383.82C321.63,388.05 314.45,396.15 314.57,396.15C314.45,396.15 310.69,399.56 308.64,401.28C304.89,404.386 300.916,407.21 296.75,409.73L297.01,409.73L296.75,409.73C292.653,412.206 288.416,414.443 284.06,416.43C287.558,417.531 291.203,418.09 294.87,418.09L296.67,418.09C304,414.1 315.65,405 330.77,383.77Z",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(38,50,56)",
      strokeWidth: "1.11px",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.77,383.77C315.65,405 304,414.1 296.73,418C315.108,417.075 329.947,402.153 330.77,383.77Z",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(38,50,56)",
      strokeWidth: "1.11px",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.89,404.57C271.327,410.147 277.326,414.277 284.12,416.43C288.476,414.443 292.713,412.206 296.81,409.73C288.27,411.31 274.91,407.39 266.89,404.57Z",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(38,50,56)",
      strokeWidth: "1.11px",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.81,409.73C300.976,407.21 304.95,404.386 308.7,401.28C282.91,403.92 267,395.93 260.24,391.39C261.516,396.198 263.781,400.687 266.89,404.57C274.91,407.39 288.27,411.31 296.81,409.73Z",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(38,50,56)",
      strokeWidth: "1.11px",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.7,401.28C310.75,399.56 312.6,397.84 314.29,396.14L312.39,396.14C312.53,396.27 312.67,396.4 312.8,396.54C312.67,396.4 312.53,396.27 312.39,396.14C297.66,395.93 286.46,393.65 278.05,390.66C265.76,386.4 261.33,381.82 259.15,379.77C259.09,380.59 259.05,381.4 259.05,382.23C259.051,385.328 259.451,388.414 260.24,391.41C267,395.93 282.91,403.92 308.7,401.28Z",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(38,50,56)",
      strokeWidth: "1.11px",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 294.77,
    cy: 382.08,
    r: 35.81,
    style: {
      fill: "none",
      stroke: "rgb(38,50,56)",
      strokeWidth: "1.11px",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.73,320.88C360.73,320.88 358.28,312.93 351.14,310.07C346.14,308.07 340.47,308.61 335.32,309.5C325.74,311.17 317.38,314.98 308.32,318.23C308.32,318.23 312.2,316.8 328.11,324.56C333.97,327.41 340.67,329.63 347.37,329.48C352.74,329.36 361,327.82 360.73,320.88Z",
    style: {
      fill: "rgb(15,152,247)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.59,297.51C361.59,297.51 361.59,289.18 355.59,284.39C351.41,281.05 345.79,279.9 340.59,279.27C330.93,278.1 321.83,279.33 312.19,279.82C312.19,279.82 316.32,279.58 329.31,291.6C334.1,296.02 339.88,300.08 346.31,301.87C351.49,303.31 359.83,304.23 361.59,297.51Z",
    style: {
      fill: "rgb(15,152,247)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378,328.42C378,328.42 371.51,323.21 371.49,315.52C371.49,310.17 374.06,305.06 376.79,300.61C381.87,292.31 388.49,285.95 394.87,278.7C394.87,278.7 392.11,281.78 393.45,299.43C393.95,305.93 393.53,312.98 390.92,319.15C388.87,324.11 384.4,331.22 378,328.42Z",
    style: {
      fill: "rgb(15,152,247)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401,341.2C401,341.2 400.08,332.93 405.5,327.47C409.26,323.68 414.71,321.88 419.78,320.66C429.24,318.38 438.42,318.55 448.05,317.92C448.05,317.92 443.93,318.15 432.41,331.59C428.17,336.59 422.9,341.24 416.69,343.77C411.74,345.8 403.56,347.67 401,341.2Z",
    style: {
      fill: "rgb(15,152,247)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.53,311.71C399.53,311.71 391.28,310.58 387.32,303.99C384.56,299.41 384.15,293.69 384.2,288.47C384.3,278.75 386.72,269.88 388.47,260.39C388.47,260.39 387.68,264.45 397.9,278.9C401.66,284.23 404.9,290.49 405.9,297.13C406.61,302.46 406.42,310.85 399.53,311.71Z",
    style: {
      fill: "rgb(15,152,247)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.27,296.9C423.27,296.9 429.2,302.74 436.84,301.9C442.15,301.29 446.93,298.12 451.03,294.9C458.67,288.9 464.22,281.56 470.67,274.39C470.67,274.39 467.94,277.48 450.25,278.21C443.74,278.48 436.79,279.71 430.96,283.03C426.28,285.65 419.75,290.92 423.27,296.9Z",
    style: {
      fill: "rgb(15,152,247)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.4,291.13C416.4,291.13 424.68,291.96 430.08,286.49C433.84,282.68 435.58,277.22 436.75,272.13C438.93,262.66 438.67,253.47 439.19,243.84C439.19,243.84 439.01,247.96 425.68,259.62C420.78,263.91 416.13,269.23 413.68,275.46C411.69,280.47 409.9,288.67 416.4,291.13Z",
    style: {
      fill: "rgb(15,152,247)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.83,371.74L372.53,336.55L356.04,295.86",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(38,50,56)",
      strokeWidth: "1.11px",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.13,365.69L404.42,316.76L419.82,286.52",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(38,50,56)",
      strokeWidth: "1.11px",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.62,346.45L409.92,338.2",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(38,50,56)",
      strokeWidth: "1.11px",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.42,316.76L397.27,300.81",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(38,50,56)",
      strokeWidth: "1.11px",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.37,300.89L430.81,293.11",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(38,50,56)",
      strokeWidth: "1.11px",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.28,343.15L381.33,318.96",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(38,50,56)",
      strokeWidth: "1.11px",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.26,324.76L353.29,317.31",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(38,50,56)",
      strokeWidth: "1.11px",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.16,389.33L382.24,389.33C378.236,389.328 374.766,386.454 374.02,382.52L369.78,360.19L406.62,360.19L402.39,382.52C401.639,386.455 398.166,389.329 394.16,389.33Z",
    style: {
      fill: "rgb(38,50,56)",
      fillRule: "nonzero",
      stroke: "rgb(38,50,56)",
      strokeWidth: "1.11px",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.15,342.28C208.89,342.28 195.51,322.53 190.76,305.16L190.6,304.55C190.417,303.94 190.323,303.305 190.323,302.668C190.323,299.08 193.276,296.128 196.863,296.128C199.922,296.128 202.592,298.273 203.25,301.26L203.37,301.71C206.98,314.93 216.81,330.04 232.58,329.17C238.574,328.962 244.206,326.215 248.06,321.62C256.71,311.7 260.58,290.13 259.72,279.25C259.697,279.049 259.685,278.847 259.685,278.644C259.685,275.775 262.046,273.414 264.915,273.414C267.699,273.414 270.021,275.638 270.14,278.42C271.14,290.53 269.82,316.56 257.91,330.21C251.75,337.463 242.828,341.817 233.32,342.21C232.59,342.26 231.86,342.28 231.15,342.28Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("g", null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M231.15,342.28C208.89,342.28 195.51,322.53 190.76,305.16L190.6,304.55C190.417,303.94 190.323,303.305 190.323,302.668C190.323,299.08 193.276,296.128 196.863,296.128C199.922,296.128 202.592,298.273 203.25,301.26L203.37,301.71C206.98,314.93 216.81,330.04 232.58,329.17C238.574,328.962 244.206,326.215 248.06,321.62C256.71,311.7 260.58,290.13 259.72,279.25C259.697,279.049 259.685,278.847 259.685,278.644C259.685,275.775 262.046,273.414 264.915,273.414C267.699,273.414 270.021,275.638 270.14,278.42C271.14,290.53 269.82,316.56 257.91,330.21C251.75,337.463 242.828,341.817 233.32,342.21C232.59,342.26 231.86,342.28 231.15,342.28Z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M264.51,273.62C261.653,273.852 259.491,276.392 259.72,279.25C260.14,284.56 259.43,292.41 257.59,300.25C260.218,300.139 262.846,300.477 265.36,301.25C264.765,308.773 262.123,315.991 257.72,322.12C248.01,335.61 233.45,339.92 222.12,338.3C217.05,337.58 211.24,334.92 206.35,332.19C212.983,338.658 221.886,342.288 231.15,342.3C231.86,342.3 232.59,342.3 233.32,342.24C242.828,341.847 251.75,337.493 257.91,330.24C269.82,316.59 271.1,290.56 270.14,278.45C269.946,275.734 267.657,273.603 264.933,273.603C264.792,273.603 264.651,273.609 264.51,273.62Z",
    style: {
      fill: "rgb(15,152,247)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.51,273.62C261.653,273.852 259.491,276.392 259.72,279.25C260.14,284.56 259.43,292.41 257.59,300.25C260.218,300.139 262.846,300.477 265.36,301.25C264.765,308.773 262.123,315.991 257.72,322.12C248.01,335.61 233.45,339.92 222.12,338.3C217.05,337.58 211.24,334.92 206.35,332.19C212.983,338.658 221.886,342.288 231.15,342.3C231.86,342.3 232.59,342.3 233.32,342.24C242.828,341.847 251.75,337.493 257.91,330.24C269.82,316.59 271.1,290.56 270.14,278.45C269.946,275.734 267.657,273.603 264.933,273.603C264.792,273.603 264.651,273.609 264.51,273.62Z",
    style: {
      fill: "white",
      fillOpacity: 0.5,
      fillRule: "nonzero"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M231.15,342.28C208.89,342.28 195.51,322.53 190.76,305.16L190.6,304.55C190.417,303.94 190.323,303.305 190.323,302.668C190.323,299.08 193.276,296.128 196.863,296.128C199.922,296.128 202.592,298.273 203.25,301.26L203.37,301.71C206.98,314.93 216.81,330.04 232.58,329.17C238.574,328.962 244.206,326.215 248.06,321.62C256.71,311.7 260.58,290.13 259.72,279.25C259.697,279.049 259.685,278.847 259.685,278.644C259.685,275.775 262.046,273.414 264.915,273.414C267.699,273.414 270.021,275.638 270.14,278.42C271.14,290.53 269.82,316.56 257.91,330.21C251.75,337.463 242.828,341.817 233.32,342.21C232.59,342.26 231.86,342.28 231.15,342.28Z",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(38,50,56)",
      strokeWidth: "1.11px",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.31,328.75C218.84,326.3 212.98,330.13 208.07,333.7C209.886,335.235 211.841,336.597 213.91,337.77C215.66,334.92 217.8,331.11 218.31,328.75Z",
    style: {
      fill: "rgb(15,152,247)",
      fillRule: "nonzero",
      stroke: "rgb(38,50,56)",
      strokeWidth: "1.11px",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.15,342.28C231.86,342.28 232.59,342.28 233.32,342.22C235.445,342.101 237.555,341.803 239.63,341.33C236.87,337.73 233.07,332.97 231.98,332.61C230.73,332.19 228.32,338.32 226.98,342.04C228.364,342.201 229.757,342.282 231.15,342.28Z",
    style: {
      fill: "rgb(15,152,247)",
      fillRule: "nonzero",
      stroke: "rgb(38,50,56)",
      strokeWidth: "1.11px",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.37,301.71L203.25,301.26C202.592,298.273 199.922,296.128 196.863,296.128C193.276,296.128 190.323,299.08 190.323,302.668C190.323,303.305 190.417,303.94 190.6,304.55L190.76,305.16C192.427,311.26 194.989,317.08 198.36,322.43L210.27,316.76C207.147,312.163 204.815,307.076 203.37,301.71Z",
    style: {
      fill: "rgb(15,152,247)",
      fillRule: "nonzero",
      stroke: "rgb(38,50,56)",
      strokeWidth: "1.11px",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.91,330.21C258.825,329.15 259.673,328.035 260.45,326.87C256.67,325.58 251.01,323.8 248.91,323.99C246.42,324.22 249.8,332.22 251.54,335.99C253.882,334.319 256.02,332.379 257.91,330.21Z",
    style: {
      fill: "rgb(15,152,247)",
      fillRule: "nonzero",
      stroke: "rgb(38,50,56)",
      strokeWidth: "1.11px",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.12,308.84C257.72,309.64 262.61,313.2 265.91,315.49C266.957,312.375 267.799,309.195 268.43,305.97C264.43,306.77 258.51,308.06 258.12,308.84Z",
    style: {
      fill: "rgb(15,152,247)",
      fillRule: "nonzero",
      stroke: "rgb(38,50,56)",
      strokeWidth: "1.11px",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.05,294.05C270.27,291.2 270.38,288.48 270.39,285.98C266.95,287.87 262.87,290.49 262.87,292.21C262.87,293.93 266.69,294.14 270.05,294.05Z",
    style: {
      fill: "rgb(15,152,247)",
      fillRule: "nonzero",
      stroke: "rgb(38,50,56)",
      strokeWidth: "1.11px",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.21,216.68C216.21,216.68 206.5,244.8 211.73,266.68C214.868,279.649 223.901,290.43 236.12,295.79C248.339,301.15 221.93,300.79 225.12,308.48C228.31,316.17 240.54,311.22 244.53,308.73C248.52,306.24 253.53,298.78 254.23,293.8C254.675,291.256 254.843,288.671 254.73,286.09C254.617,283.509 270.9,284.35 281.85,275.39C281.85,275.39 291.56,283.1 298.53,281.61C305.5,280.12 315.45,267.67 314.45,256.48C313.45,245.29 307,245.3 303.06,247C301.015,247.773 299.15,248.958 297.58,250.48C296.01,252.002 303.3,243.48 297.58,233.81C294.162,228.067 288.28,224.208 281.65,223.36C275.02,222.512 278.65,207.43 269.71,201.46C260.77,195.49 228.9,189.31 216.21,216.68Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("g", null, _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M216.21,216.68C216.21,216.68 206.5,244.8 211.73,266.68C214.868,279.649 223.901,290.43 236.12,295.79C248.339,301.15 221.93,300.79 225.12,308.48C228.31,316.17 240.54,311.22 244.53,308.73C248.52,306.24 253.53,298.78 254.23,293.8C254.675,291.256 254.843,288.671 254.73,286.09C254.617,283.509 270.9,284.35 281.85,275.39C281.85,275.39 291.56,283.1 298.53,281.61C305.5,280.12 315.45,267.67 314.45,256.48C313.45,245.29 307,245.3 303.06,247C301.015,247.773 299.15,248.958 297.58,250.48C296.01,252.002 303.3,243.48 297.58,233.81C294.162,228.067 288.28,224.208 281.65,223.36C275.02,222.512 278.65,207.43 269.71,201.46C260.77,195.49 228.9,189.31 216.21,216.68Z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M290.14,226.35C280.782,241.961 264.423,252.113 246.28,253.57C226.48,255.31 215.38,251.41 210.28,248.7C210.899,237.82 212.915,227.065 216.28,216.7C228.97,189.33 260.82,195.55 269.78,201.52C278.74,207.49 281.72,223.42 281.72,223.42C284.701,223.794 287.57,224.793 290.14,226.35ZM303.06,247C301.015,247.773 299.15,248.958 297.58,250.48C298.791,248.81 299.59,246.878 299.91,244.84C286.46,251.54 287.51,265.84 285.84,265.84C283.78,265.84 282.76,258.65 282.76,258.65C282.76,258.65 280.19,268.92 264.76,276.12C249.33,283.32 231.88,277.66 231.88,277.66C231.88,277.66 235.48,285.88 226.23,284.85C223.634,284.602 221.145,283.693 219,282.21C223.435,288.123 229.327,292.789 236.1,295.75C242.873,298.711 221.91,300.75 225.1,308.44C228.29,316.13 240.53,311.18 244.51,308.69C248.49,306.2 253.51,298.74 254.21,293.76C254.655,291.216 254.823,288.631 254.71,286.05C254.597,283.469 270.88,284.31 281.83,275.35C281.83,275.35 291.54,283.06 298.51,281.57C305.48,280.08 315.43,267.63 314.43,256.44C313.43,245.25 307,245.3 303.06,247Z",
    style: {
      fill: "rgb(15,152,247)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.14,226.35C280.782,241.961 264.423,252.113 246.28,253.57C226.48,255.31 215.38,251.41 210.28,248.7C210.899,237.82 212.915,227.065 216.28,216.7C228.97,189.33 260.82,195.55 269.78,201.52C278.74,207.49 281.72,223.42 281.72,223.42C284.701,223.794 287.57,224.793 290.14,226.35ZM303.06,247C301.015,247.773 299.15,248.958 297.58,250.48C298.791,248.81 299.59,246.878 299.91,244.84C286.46,251.54 287.51,265.84 285.84,265.84C283.78,265.84 282.76,258.65 282.76,258.65C282.76,258.65 280.19,268.92 264.76,276.12C249.33,283.32 231.88,277.66 231.88,277.66C231.88,277.66 235.48,285.88 226.23,284.85C223.634,284.602 221.145,283.693 219,282.21C223.435,288.123 229.327,292.789 236.1,295.75C242.873,298.711 221.91,300.75 225.1,308.44C228.29,316.13 240.53,311.18 244.51,308.69C248.49,306.2 253.51,298.74 254.21,293.76C254.655,291.216 254.823,288.631 254.71,286.05C254.597,283.469 270.88,284.31 281.83,275.35C281.83,275.35 291.54,283.06 298.51,281.57C305.48,280.08 315.43,267.63 314.43,256.44C313.43,245.25 307,245.3 303.06,247Z",
    style: {
      fill: "white",
      fillOpacity: 0.5,
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.78,286.11C243.911,286.399 233.502,281.626 226.63,273.2",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(38,50,56)",
      strokeWidth: "1.11px",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M216.21,216.68C216.21,216.68 206.5,244.8 211.73,266.68C214.868,279.649 223.901,290.43 236.12,295.79C248.339,301.15 221.93,300.79 225.12,308.48C228.31,316.17 240.54,311.22 244.53,308.73C248.52,306.24 253.53,298.78 254.23,293.8C254.675,291.256 254.843,288.671 254.73,286.09C254.617,283.509 270.9,284.35 281.85,275.39C281.85,275.39 291.56,283.1 298.53,281.61C305.5,280.12 315.45,267.67 314.45,256.48C313.45,245.29 307,245.3 303.06,247C301.015,247.773 299.15,248.958 297.58,250.48C296.01,252.002 303.3,243.48 297.58,233.81C294.162,228.067 288.28,224.208 281.65,223.36C275.02,222.512 278.65,207.43 269.71,201.46C260.77,195.49 228.9,189.31 216.21,216.68Z",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(38,50,56)",
      strokeWidth: "1.11px",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.58,250.52C297.58,250.52 292.36,254.01 289.87,264.71",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(38,50,56)",
      strokeWidth: "1.11px",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.17,255.1C306.56,256.92 304.89,258.01 303.45,257.52C302.01,257.03 301.35,255.16 301.96,253.34C302.57,251.52 304.24,250.43 305.68,250.92C307.12,251.41 307.79,253.28 307.17,255.1Z",
    style: {
      fill: "white",
      fillRule: "nonzero",
      stroke: "rgb(38,50,56)",
      strokeWidth: "1.11px",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.32,258.34C311.71,260.16 310.04,261.25 308.6,260.76C307.16,260.27 306.49,258.4 307.11,256.58C307.73,254.76 309.39,253.67 310.83,254.16C312.27,254.65 312.94,256.52 312.32,258.34Z",
    style: {
      fill: "white",
      fillRule: "nonzero",
      stroke: "rgb(38,50,56)",
      strokeWidth: "1.11px",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.42,263.19C313.049,263.812 312.375,264.195 311.651,264.195C310.521,264.195 309.591,263.265 309.591,262.135C309.591,261.005 310.521,260.075 311.651,260.075C311.882,260.075 312.112,260.114 312.33,260.19C313.426,260.738 313.909,262.066 313.42,263.19Z",
    style: {
      fill: "white",
      fillRule: "nonzero",
      stroke: "rgb(38,50,56)",
      strokeWidth: "1.11px",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.85,269.85C305.05,273.1 301.45,274.54 298.8,273.07C296.15,271.6 295.47,267.79 297.27,264.54C299.07,261.29 302.67,259.85 305.32,261.32C307.97,262.79 308.65,266.6 306.85,269.85Z",
    style: {
      fill: "white",
      fillRule: "nonzero",
      stroke: "rgb(38,50,56)",
      strokeWidth: "1.11px",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.12,295.81C239.471,297.37 243.284,297.637 246.82,296.56",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(38,50,56)",
      strokeWidth: "1.11px",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.17,308.5C225.17,308.5 226.17,304.27 232.38,301.29",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(38,50,56)",
      strokeWidth: "1.11px",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.39,312.24C231.39,312.24 233.88,306.24 238.11,303.53",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(38,50,56)",
      strokeWidth: "1.11px",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.26,243.4C131.116,241.689 129.917,239.05 130.04,236.31L130.04,212.6L68.88,212.6C65.858,212.713 62.934,211.499 60.88,209.28C58.88,207.165 57.782,204.351 57.82,201.44C57.812,199.074 58.508,196.759 59.82,194.79L118.4,102.73C122.8,95.937 128.647,92.54 135.94,92.54C139.86,92.407 143.691,93.749 146.67,96.3C149.53,98.8 150.96,102.517 150.96,107.45L150.96,196.94L166.52,196.94C168.694,196.809 170.818,197.653 172.31,199.24C175.016,202.412 175.016,207.128 172.31,210.3C170.818,211.887 168.694,212.731 166.52,212.6L150.85,212.6L150.85,236.31C150.981,239.028 149.829,241.656 147.74,243.4C145.728,245.087 143.176,245.999 140.55,245.97C137.895,245.991 135.315,245.081 133.26,243.4ZM130,196.94L130,114.54L78.71,196.94L130,196.94Z",
    style: {
      fill: "rgb(38,50,56)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.13,243.88C212.136,241.264 206.827,237.297 202.62,232.29C198.394,227 195.094,221.032 192.86,214.64C190.328,207.735 188.548,200.577 187.55,193.29C186.509,185.356 186.008,177.361 186.05,169.36C186.05,116.647 204.05,90.29 240.05,90.29C276.05,90.29 294.007,116.647 293.92,169.36C293.956,177.323 293.471,185.28 292.47,193.18C291.505,200.468 289.741,207.628 287.21,214.53C284.976,220.922 281.676,226.89 277.45,232.18C273.237,237.194 267.931,241.176 261.94,243.82C255.052,246.865 247.58,248.367 240.05,248.22C232.516,248.371 225.038,246.891 218.13,243.88ZM250.69,228.75C253.702,227.465 256.436,225.607 258.74,223.28C261.073,220.796 262.991,217.953 264.42,214.86C265.997,211.583 267.273,208.169 268.23,204.66C269.238,200.837 269.974,196.947 270.43,193.02C270.97,188.687 271.33,184.717 271.51,181.11C271.69,177.503 271.777,173.587 271.77,169.36C271.77,164.927 271.683,160.833 271.51,157.08C271.337,153.327 270.96,149.3 270.38,145C269.882,141.075 269.131,137.187 268.13,133.36C267.184,129.886 265.908,126.511 264.32,123.28C262.88,120.236 260.958,117.443 258.63,115.01C256.34,112.73 253.621,110.925 250.63,109.7C243.795,107.061 236.215,107.061 229.38,109.7C226.411,110.91 223.712,112.698 221.44,114.96C219.129,117.383 217.212,120.153 215.76,123.17C214.158,126.372 212.898,129.734 212,133.2C211.024,137.05 210.289,140.958 209.8,144.9C209.22,149.26 208.843,153.32 208.67,157.08C208.497,160.84 208.407,164.933 208.4,169.36C208.4,173.58 208.49,177.513 208.67,181.16C208.85,184.807 209.207,188.807 209.74,193.16C210.201,197.087 210.936,200.976 211.94,204.8C212.884,208.308 214.146,211.722 215.71,215C217.125,218.074 219.026,220.901 221.34,223.37C223.627,225.682 226.345,227.524 229.34,228.79C236.181,231.575 243.849,231.575 250.69,228.79L250.69,228.75Z",
    style: {
      fill: "rgb(38,50,56)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.58,243.4C384.436,241.689 383.237,239.05 383.36,236.31L383.36,212.6L322.2,212.6C319.178,212.713 316.254,211.499 314.2,209.28C312.2,207.165 311.102,204.351 311.14,201.44C311.132,199.074 311.828,196.759 313.14,194.79L371.72,102.73C376.08,95.937 381.91,92.54 389.21,92.54C393.15,92.392 397.005,93.735 400,96.3C402.86,98.8 404.29,102.517 404.29,107.45L404.29,196.94L419.85,196.94C422.024,196.809 424.148,197.653 425.64,199.24C428.346,202.412 428.346,207.128 425.64,210.3C424.148,211.887 422.024,212.731 419.85,212.6L404.17,212.6L404.17,236.31C404.301,239.028 403.149,241.656 401.06,243.4C399.048,245.087 396.496,245.999 393.87,245.97C391.215,245.991 388.635,245.081 386.58,243.4ZM383.36,196.94L383.36,114.54L332.07,196.94L383.36,196.94Z",
    style: {
      fill: "rgb(38,50,56)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.05,202.5C196.05,202.5 185.6,217.18 184.11,232.11C182.62,247.04 184.36,256.99 188.84,260.73C193.32,264.47 197.79,262.97 200.28,259.48C202.77,255.99 198.79,243.8 198.79,243.8C198.79,243.8 203.02,232.11 209.49,223.9C215.96,215.69 217.2,214.44 217.2,214.44C217.2,214.44 206,201.75 196.05,202.5Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("g", null, _clipPath3 || (_clipPath3 = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M196.05,202.5C196.05,202.5 185.6,217.18 184.11,232.11C182.62,247.04 184.36,256.99 188.84,260.73C193.32,264.47 197.79,262.97 200.28,259.48C202.77,255.99 198.79,243.8 198.79,243.8C198.79,243.8 203.02,232.11 209.49,223.9C215.96,215.69 217.2,214.44 217.2,214.44C217.2,214.44 206,201.75 196.05,202.5Z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M196.05,202.5C193.77,205.869 191.747,209.406 190,213.08C195,215.08 202.75,219.18 207.67,226.44C208.27,225.57 208.89,224.71 209.53,223.9C216,215.69 217.24,214.44 217.24,214.44C217.24,214.44 206,201.75 196.05,202.5Z",
    style: {
      fill: "rgb(15,152,247)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.05,202.5C193.77,205.869 191.747,209.406 190,213.08C195,215.08 202.75,219.18 207.67,226.44C208.27,225.57 208.89,224.71 209.53,223.9C216,215.69 217.24,214.44 217.24,214.44C217.24,214.44 206,201.75 196.05,202.5Z",
    style: {
      fill: "white",
      fillOpacity: 0.5,
      fillRule: "nonzero"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M196.05,202.5C196.05,202.5 185.6,217.18 184.11,232.11C182.62,247.04 184.36,256.99 188.84,260.73C193.32,264.47 197.79,262.97 200.28,259.48C202.77,255.99 198.79,243.8 198.79,243.8C198.79,243.8 203.02,232.11 209.49,223.9C215.96,215.69 217.2,214.44 217.2,214.44C217.2,214.44 206,201.75 196.05,202.5Z",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(38,50,56)",
      strokeWidth: "1.11px",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.84,260.73C187.618,257.467 187.024,254.003 187.09,250.52",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(38,50,56)",
      strokeWidth: "1.11px",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.55,262.22C195.55,262.22 193.07,257.99 192.82,250.77",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(38,50,56)",
      strokeWidth: "1.11px",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.29,229.12C199.29,226.5 194.29,221.38 187.34,219.12C186.406,221.556 185.634,224.052 185.03,226.59C187.73,227.052 190.352,227.89 192.82,229.08C196.55,231.11 199.29,232.11 199.29,229.12Z",
    style: {
      fill: "rgb(15,152,247)",
      fillRule: "nonzero",
      stroke: "rgb(38,50,56)",
      strokeWidth: "1.11px",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.44,203.39C193.828,205.847 192.346,208.387 191,211C193.104,211.556 195.123,212.398 197,213.5C204.71,217.97 206.2,218.5 203.72,212C202.22,207.92 198.64,205.15 195.44,203.39Z",
    style: {
      fill: "rgb(15,152,247)",
      fillRule: "nonzero",
      stroke: "rgb(38,50,56)",
      strokeWidth: "1.11px",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.9,195.25C277.9,195.25 289.74,208.83 292.69,223.55C295.64,238.27 294.89,248.34 290.79,252.49C286.69,256.64 282.1,255.6 279.28,252.37C276.46,249.14 279.28,236.63 279.28,236.63C279.28,236.63 273.92,225.4 266.68,217.86C259.44,210.32 258.07,209.21 258.07,209.21C258.07,209.21 267.92,195.48 277.9,195.25Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("g", null, _clipPath4 || (_clipPath4 = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M277.9,195.25C277.9,195.25 289.74,208.83 292.69,223.55C295.64,238.27 294.89,248.34 290.79,252.49C286.69,256.64 282.1,255.6 279.28,252.37C276.46,249.14 279.28,236.63 279.28,236.63C279.28,236.63 273.92,225.4 266.68,217.86C259.44,210.32 258.07,209.21 258.07,209.21C258.07,209.21 267.92,195.48 277.9,195.25Z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M277.9,195.25C267.9,195.48 258.02,209.25 258.02,209.25C258.02,209.25 259.38,210.37 266.63,217.9C267.986,219.328 269.261,220.83 270.45,222.4C274.234,216.009 279.64,210.73 286.12,207.1C283.735,202.915 280.985,198.949 277.9,195.25Z",
    style: {
      fill: "rgb(15,152,247)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.9,195.25C267.9,195.48 258.02,209.25 258.02,209.25C258.02,209.25 259.38,210.37 266.63,217.9C267.986,219.328 269.261,220.83 270.45,222.4C274.234,216.009 279.64,210.73 286.12,207.1C283.735,202.915 280.985,198.949 277.9,195.25Z",
    style: {
      fill: "white",
      fillOpacity: 0.5,
      fillRule: "nonzero"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M277.9,195.25C277.9,195.25 289.74,208.83 292.69,223.55C295.64,238.27 294.89,248.34 290.79,252.49C286.69,256.64 282.1,255.6 279.28,252.37C276.46,249.14 279.28,236.63 279.28,236.63C279.28,236.63 273.92,225.4 266.68,217.86C259.44,210.32 258.07,209.21 258.07,209.21C258.07,209.21 267.92,195.48 277.9,195.25Z",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(38,50,56)",
      strokeWidth: "1.11px",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.79,252.49C291.686,249.128 291.938,245.626 291.53,242.17",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(38,50,56)",
      strokeWidth: "1.11px",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.25,254.63C284.25,254.63 286.32,250.18 285.86,242.97",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(38,50,56)",
      strokeWidth: "1.11px",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.29,222.06C277.04,219.45 281.51,213.87 288.21,210.98C289.369,213.311 290.371,215.716 291.21,218.18C288.573,218.915 286.05,220.009 283.71,221.43C280.21,223.78 277.59,225 277.29,222.06Z",
    style: {
      fill: "rgb(15,152,247)",
      fillRule: "nonzero",
      stroke: "rgb(38,50,56)",
      strokeWidth: "1.11px",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.59,196.08C280.429,198.349 282.145,200.716 283.73,203.17C281.683,203.928 279.749,204.961 277.98,206.24C270.75,211.46 269.31,212.1 271.15,205.42C272.3,201.25 275.58,198.14 278.59,196.08Z",
    style: {
      fill: "rgb(15,152,247)",
      fillRule: "nonzero",
      stroke: "rgb(38,50,56)",
      strokeWidth: "1.11px",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.07,189.8C195.07,189.8 191.99,200.19 193.15,204.42C194.31,208.65 199.69,204.81 205.08,209.42C210.47,214.03 215.46,222.35 235.87,223.89C256.28,225.43 268.6,214.42 272.87,208.26C277.14,202.1 276.72,194.79 284.03,194.41C291.34,194.03 285.19,179.78 282.88,177.47C282.88,177.47 297.12,156.3 297.12,150.91C297.12,145.52 283.65,146.67 267.12,151.68C267.12,151.68 254.8,145.13 232.47,148.98C210.14,152.83 203.6,159.38 203.6,159.38C203.6,159.38 175.88,162.84 173.96,166.3C172.04,169.76 177.75,184.41 195.07,189.8Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("g", null, _clipPath5 || (_clipPath5 = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M195.07,189.8C195.07,189.8 191.99,200.19 193.15,204.42C194.31,208.65 199.69,204.81 205.08,209.42C210.47,214.03 215.46,222.35 235.87,223.89C256.28,225.43 268.6,214.42 272.87,208.26C277.14,202.1 276.72,194.79 284.03,194.41C291.34,194.03 285.19,179.78 282.88,177.47C282.88,177.47 297.12,156.3 297.12,150.91C297.12,145.52 283.65,146.67 267.12,151.68C267.12,151.68 254.8,145.13 232.47,148.98C210.14,152.83 203.6,159.38 203.6,159.38C203.6,159.38 175.88,162.84 173.96,166.3C172.04,169.76 177.75,184.41 195.07,189.8Z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M284,194.42C291.32,194.03 285.16,179.79 282.85,177.48C282.85,177.48 285.56,173.48 288.61,168.48C280.34,164.16 272.22,161.76 270.06,164.19C265.41,169.41 267.94,179.41 270.06,189.19C272.18,198.97 263.71,203.14 257.79,211.6C251.87,220.06 243.42,210.75 243.42,210.75C240.42,223.02 227.77,214.98 227.77,214.98C218.05,211.98 201.56,202.3 204.94,195.53C208.32,188.76 209.17,182.42 203.25,176.93C197.33,171.44 173.72,166.87 173.72,166.87C172.48,171.04 178.47,184.7 195.08,189.87C195.08,189.87 192,200.26 193.16,204.49C194.32,208.72 199.7,204.88 205.09,209.49C210.48,214.1 215.47,222.42 235.88,223.96C256.29,225.5 268.61,214.49 272.88,208.33C277.15,202.17 276.68,194.8 284,194.42Z",
    style: {
      fill: "rgb(15,152,247)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284,194.42C291.32,194.03 285.16,179.79 282.85,177.48C282.85,177.48 285.56,173.48 288.61,168.48C280.34,164.16 272.22,161.76 270.06,164.19C265.41,169.41 267.94,179.41 270.06,189.19C272.18,198.97 263.71,203.14 257.79,211.6C251.87,220.06 243.42,210.75 243.42,210.75C240.42,223.02 227.77,214.98 227.77,214.98C218.05,211.98 201.56,202.3 204.94,195.53C208.32,188.76 209.17,182.42 203.25,176.93C197.33,171.44 173.72,166.87 173.72,166.87C172.48,171.04 178.47,184.7 195.08,189.87C195.08,189.87 192,200.26 193.16,204.49C194.32,208.72 199.7,204.88 205.09,209.49C210.48,214.1 215.47,222.42 235.88,223.96C256.29,225.5 268.61,214.49 272.88,208.33C277.15,202.17 276.68,194.8 284,194.42Z",
    style: {
      fill: "white",
      fillOpacity: 0.5,
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.89,196.74C254.18,199.18 248.76,201.81 241.81,202.62C234.86,203.43 228.98,202.11 228.69,199.62C228.4,197.13 233.82,194.56 240.78,193.75C247.74,192.94 253.61,194.31 253.89,196.74Z",
    style: {
      fill: "rgb(15,152,247)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.89,196.74C254.18,199.18 248.76,201.81 241.81,202.62C234.86,203.43 228.98,202.11 228.69,199.62C228.4,197.13 233.82,194.56 240.78,193.75C247.74,192.94 253.61,194.31 253.89,196.74Z",
    style: {
      fill: "white",
      fillOpacity: 0.5,
      fillRule: "nonzero"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M195.07,189.8C195.07,189.8 191.99,200.19 193.15,204.42C194.31,208.65 199.69,204.81 205.08,209.42C210.47,214.03 215.46,222.35 235.87,223.89C256.28,225.43 268.6,214.42 272.87,208.26C277.14,202.1 276.72,194.79 284.03,194.41C291.34,194.03 285.19,179.78 282.88,177.47C282.88,177.47 297.12,156.3 297.12,150.91C297.12,145.52 283.65,146.67 267.12,151.68C267.12,151.68 254.8,145.13 232.47,148.98C210.14,152.83 203.6,159.38 203.6,159.38C203.6,159.38 175.88,162.84 173.96,166.3C172.04,169.76 177.75,184.41 195.07,189.8Z",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(38,50,56)",
      strokeWidth: "1.11px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.69,159C264.69,165.72 268.22,172.44 272.69,176.17C275.42,178.45 279.82,178.17 282.83,177.53C285.84,176.89 297.07,156.36 297.07,150.97C297.08,150.92 284.64,152.23 274.69,159Z",
    style: {
      fill: "rgb(15,152,247)",
      fillRule: "nonzero",
      stroke: "rgb(38,50,56)",
      strokeWidth: "1.11px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.71,166.8C172.47,170.97 178.46,184.63 195.07,189.8C195.07,189.8 207.75,188.56 203.52,178.36C199.57,168.84 179.6,166.47 173.71,166.8Z",
    style: {
      fill: "rgb(15,152,247)",
      fillRule: "nonzero",
      stroke: "rgb(38,50,56)",
      strokeWidth: "1.11px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.41,149C231.1,149.23 229.84,149.47 228.63,149.71C230.63,159.81 233.92,176.63 236.86,176.63C239.8,176.63 242.05,158.19 243.01,147.86C239.456,148.01 235.915,148.39 232.41,149Z",
    style: {
      fill: "rgb(15,152,247)",
      fillRule: "nonzero",
      stroke: "rgb(38,50,56)",
      strokeWidth: "1.11px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.94,173.63C224,171.83 223.54,158.3 223.05,150.96C219.892,151.745 216.783,152.716 213.74,153.87C214.85,160.74 217.67,175.55 220.94,173.63Z",
    style: {
      fill: "rgb(15,152,247)",
      fillRule: "nonzero",
      stroke: "rgb(38,50,56)",
      strokeWidth: "1.11px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.55,167.41C253.68,168.51 255.44,157.26 256.43,148.6C253.269,148.085 250.073,147.814 246.87,147.79C246.77,154.9 247.16,166.22 250.55,167.41Z",
    style: {
      fill: "rgb(15,152,247)",
      fillRule: "nonzero",
      stroke: "rgb(38,50,56)",
      strokeWidth: "1.11px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.36,206.35C243.441,205.583 240.335,205.966 237.69,207.42C237.424,207.573 237.26,207.858 237.26,208.165C237.26,208.401 237.358,208.628 237.53,208.79L242.84,213.79C242.999,213.939 243.21,214.022 243.428,214.022C243.764,214.022 244.07,213.826 244.21,213.52L246.93,207.52C246.976,207.413 247,207.298 247,207.181C247,206.792 246.736,206.45 246.36,206.35Z",
    style: {
      fill: "rgb(15,152,247)",
      fillRule: "nonzero",
      stroke: "rgb(38,50,56)",
      strokeWidth: "1.11px",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.74,198C234.47,199.93 234.18,201.83 233.09,202.24C232,202.65 230.52,201.43 229.78,199.51C229.04,197.59 229.34,195.68 230.43,195.27C231.52,194.86 233,196.08 233.74,198Z",
    style: {
      fill: "rgb(38,50,56)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.22,196.63C247.84,198.63 248.46,200.48 249.61,200.69C250.76,200.9 252,199.44 252.38,197.41C252.76,195.38 252.14,193.57 250.99,193.35C249.84,193.13 248.6,194.61 248.22,196.63Z",
    style: {
      fill: "rgb(38,50,56)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.21,213.51C244.21,213.51 237.11,223.15 230.64,213.45",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(38,50,56)",
      strokeWidth: "1.11px",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.84,213.78C242.84,213.78 247.56,218.67 252.54,215.93C257.52,213.19 254.54,208.93 254.54,208.93",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(38,50,56)",
      strokeWidth: "1.11px",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.19,190.3C221.19,190.3 222.93,184.08 231.14,185.57",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(38,50,56)",
      strokeWidth: "3.34px",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.07,184.58C246.07,184.58 252.29,180.85 258.01,186.82",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(38,50,56)",
      strokeWidth: "3.34px",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.46,206.98L222.43,208.47",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(38,50,56)",
      strokeWidth: "1.11px",
      strokeLinecap: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.68,210.71L216.46,211.7",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(38,50,56)",
      strokeWidth: "1.11px",
      strokeLinecap: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.68,213.45L218.95,215.44",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(38,50,56)",
      strokeWidth: "1.11px",
      strokeLinecap: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.5,204.24L265.73,202.99",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(38,50,56)",
      strokeWidth: "1.11px",
      strokeLinecap: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.5,206.73L264.98,206.73",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(38,50,56)",
      strokeWidth: "1.11px",
      strokeLinecap: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.24,209.22L266.97,210.46",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(38,50,56)",
      strokeWidth: "1.11px",
      strokeLinecap: "round"
    }
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "freepik--yarn-ball--inject-35"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-35"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-35"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgError404);
export default __webpack_public_path__ + "static/media/error-404.6479539675ed505f535c0e5d381016a2.svg";
export { ForwardRef as ReactComponent };